import React from 'react'
import styled from 'styled-components'
import { colors } from 'utils'
import SelectField from './SelectField'
import { SelectFieldProps } from '../types'

const S = {
    MatchingField: styled(SelectField)<SelectFieldProps & { error?: boolean }>`
        display: grid;
        align-items: center;
        grid-template-columns: repeat(3, 1fr);
        padding: 0;
        margin-bottom: 6px;
        
        & label {
            margin-bottom: 0;
            color: ${({ error }) => (error ? colors.danger : 'unset')};
        }

        & .matching-arrow {
            opacity: 0.25;
            &:after {
                content: "";
                display: inline-block !important;
                width: 0;
                height: 0;
                border-left: 7px solid ${colors.icon};
                border-top: 5px solid transparent;
                border-bottom: 5px solid transparent;
                vertical-align: middle;
            }

            &:before {
                width: 75%;
                height: 0;
                border-top: 1px solid ${colors.icon};
                content: "";
                display: inline-block;
                vertical-align: middle;
            }
        }
        & .select-field {
            width: 100%;
        }
    `
}

const MatchingField = (props: SelectFieldProps & { error?: boolean }) => (
    <S.MatchingField {...props} />
)

export default MatchingField
